import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToAnchor = (delay: number = 100) => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, delay);
    }
  }, [location.hash, delay]); // Додаємо location.hash в залежності
};